import { InstagramInfluencers, InstagramInfluencerProfile } from '@anytag/shared-organisms';
import { InfluencersTabType } from '@anytag/shared-types';
import { useSocialAccountSelectButtonProps } from './hooks';

export const InstagramInfluencersSearch = () => {
  const { getSortSelectButtonProps, getListSelectButtonProps } =
    useSocialAccountSelectButtonProps<InstagramInfluencerProfile>({
      socialMedia: InfluencersTabType.INSTAGRAM
    });

  return (
    <InstagramInfluencers
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
